import React from 'react'
import PropTypes from 'prop-types'
import AbundanceParser from '../../../../../../../abundanceEngine/AbundanceParser'
import FlexRow from '../../../../../../molecules/FlexRow'
import SydButton from '../../../../../../commonDesign/Button'
import FadeIn from '../../../../../../molecules/Transitions/FadeIn'
import ErrorBoundary from '../../../../../../molecules/ErrorBoundary'

function JsxPreview ({ title, jsx, onEdit }) {
  return (
    <FadeIn>
      <FlexRow className='bg-neutral-200 px-2 justify-between' style={{ height: '30px', maxHeight: '30px', borderBottom: 'var(--border-neutral-thin)' }}>
        <div>{title}</div>
        <div>
          <SydButton size='xs' variant='primary' className='radius-xs' onClick={onEdit}>Edit</SydButton>
        </div>
      </FlexRow>
      <ErrorBoundary name='Preview View'>
        <AbundanceParser jsx={jsx} />
      </ErrorBoundary>
    </FadeIn>
  )
}

JsxPreview.propTypes = {
  jsx: PropTypes.string,
  title: PropTypes.string,
  onEdit: PropTypes.func
}

export default JsxPreview
